import { useEffect, useState } from "react";
import axios from "axios";
import { fetchSimDocumentsToken } from "../../authentication/AuthenticationHelper";

export function useProductCompanies() {
  const [productCompanies, setProductCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchProductCompanies = async () => {
      const token = await fetchSimDocumentsToken();
      if (token) {
        try {
          const config = {
            headers: { Authorization: `Bearer ${token}` },
          };
          const apiResponse = await axios.get(
            process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL + "/v1/SIMDocuments/ProductCompanies",
            config
          );
          const productCompanyList = apiResponse.data.map((productCompany: any) => ({
            key: productCompany.code,
            label: productCompany.description,
          }));
          setProductCompanies(productCompanyList);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchProductCompanies();
  }, []);

  return { productCompanies, loading };
}

export function useExternalCompanies() {
  const [externalCompanies, setExternalCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchExternalCompanies = async () => {
      const token = await fetchSimDocumentsToken();
      if (token) {
        try {
          const config = {
            headers: { Authorization: `Bearer ${token}` },
          };
          const apiResponse = await axios.get(
            process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL + "/v1/SIMDocuments/ExternalCompanies",
            config
          );
          const externalCompanyList = apiResponse.data.map((externalCompany: any) => ({
            key: externalCompany.code,
            label: externalCompany.description ,
          }));
          setExternalCompanies(externalCompanyList);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchExternalCompanies();
  }, []);

  return { externalCompanies, loading };
}